<template>
     <div class="workflow-container">
  <!-- Card -->
  <div class="workflow-card">
    <div ><img src="~@/assets/images/link.svg" width="12px" alt="" /></div>

    <div class="content">
      <div class="header">
        <h3>{{ data.workflow_version.workflow_template.name }}</h3>
        <span class="status" :class="getStatusClass(data.state_value.name)">{{ data.state_value.name }}</span>
      </div>

      <p class="stage"></p>

      <div class="meta">
        <span>• {{ data.created_by_user.first_name }} {{ data.created_by_user.last_name }}</span>
        <span>•</span> {{  }}
        <span>🕒 {{ data.created_on }} - {{ data.end_Date === null ? 'Ongoing' : data.end_Date }}</span>
      </div>
    </div>
  </div>

</div>
</template>
<script>
export default ({
  name: 'WorkflowHistory',
  props: {
    data: { type: Object, default: () => ({}) }
  },
  methods: {
    getStatusClass (status) {
      switch (status) {
      case 'COMPLETED':
        return 'status-completed'
      case 'ONGOING':
        return 'status-ongoing'
      case 'REJECTED':
        return 'status-rejected'
      default:
        return ''
      }
    }
  }
})
</script>
<style lang="scss" scoped>
.workflow-container {
  width: 560px;
  margin: 20px auto;
}

.workflow-card {
  display: flex;
  gap: 15px;
  background: #fff;
  border: 1px solid #e2e6ea;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 12px;
  align-items: flex-start;
}

/* Content */
.content {
  flex: 1;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header h3 {
  font-size: 15px;
  margin: 0;
  color: #2f3a4a;
}
.status {
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 5px;
  &-completed {
    background-color: #d4edda; /* Light green */
    color: #155724;
  }
   &-ongoing {
        background-color: #fff3cd; /* Light yellow */
        color: #856404; /* Dark yellow */
    }
  &-rejected {
      background-color: #ffcccc; /* Light red */
      color: #d60000; /* Dark red */
    }
}
.stage {
  margin: 6px 0;
  font-size: 13px;
  color: #6b778c;
}
.meta {
  display: flex;
  gap: 8px;
  font-size: 12px;
  color: #7a869a;
}
@media (max-width: 480px) {
  .history-body-basic-right{
    flex-direction: column-reverse;
    gap:0px;
  }
}

/* Tablets (portrait and small tablets: 481px - 767px) */
@media (min-width: 481px) and (max-width: 767px) {
 .history-body-basic-right{
    flex-direction: column-reverse;
    gap:0px;
  }

}

/* Tablets (standard: 768px - 1024px) */
@media (min-width: 768px) and (max-width: 1024px) {
  /* Standard tablet styles here */
}

/* Laptops (1025px - 1280px) */
@media (min-width: 1025px) and (max-width: 1280px) {
  /* Laptop styles here */
}

/* Desktops (1281px - 1600px) */
@media (min-width: 1281px) and (max-width: 1600px) {
  /* Desktop styles here */
}

/* Big Screens (1601px and up) */
@media (min-width: 1601px) {
  /* Big screen styles here */
}

</style>
